import { Reveal } from "./Reveal";

export const SectionHead = ({ kicker, title, light = false, className = "" }) => (
  <Reveal className={`mb-12 md:mb-20 ${className}`}>
    <div className="mb-6 flex items-center gap-3">
      <span className="h-2.5 w-2.5 bg-orange" aria-hidden="true" />
      <span className={`font-oswald text-xs uppercase tracking-[0.25em] md:text-sm ${light ? "text-bone/80" : "text-navy"}`}>
        {kicker}
      </span>
    </div>
    <h2 className="max-w-4xl font-oswald text-4xl font-semibold uppercase leading-[0.95] tracking-tight md:text-6xl">
      {title}
    </h2>
  </Reveal>
);
